import React from 'react';
import styles from './RegPlateInput.module.css';

export const RegPlateInput: React.FC<
  React.PropsWithChildren<{
    label: string;
    showLabel?: boolean;
    inputName?: string;
    validationError?: string;
    className?: string;
    ref?: React.Ref<HTMLInputElement>;
  }> &
    React.InputHTMLAttributes<HTMLInputElement>
> = ({ label, showLabel = true, inputName = 'reg', validationError, children, className, ref, ...props }) => {
  return (
    <div>
      <label className={`tc-label mb-1 block pl-[1px] ${showLabel ? '' : 'sr-only'}`} htmlFor={inputName}>
        {label}
      </label>
      <div>
        <div className={`${styles.fieldContainer} mb-1 flex`}>
          <div className="font-purista bg-neutral border-dark-200 flex min-h-full w-18 items-center justify-center rounded-tl-lg rounded-bl-lg border-t-1 border-r-1 border-b-1 border-l-1 text-lg font-bold">
            GB
          </div>
          <input
            ref={ref}
            name={inputName}
            id={inputName}
            className={`font-purista border-dark-200 text-dark block w-full rounded-tr-lg rounded-br-lg border-t-1 border-r-1 border-b-1 py-3 pr-18 pl-3 text-center text-4xl uppercase outline-0 ${styles.inputField} ${className}`}
            {...props}
          />
        </div>
        {children}
        {validationError && (
          <p className={`${styles.validationError} text-error mt-2 mb-1 text-sm`}>{validationError}</p>
        )}
      </div>
    </div>
  );
};
